export default __webpack_public_path__ + "static/DW-Google-Lime-f48cd1f183aad0fb1b682f1d6d838d6f.svg";